// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItems from 'menu-items';
import useContractPermissions from 'hooks/useContractPermissions';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const { canManageUsers, canViewCommissionReports, canViewAttendances, isSuperuser } = useContractPermissions();

    // Filtra os itens de menu baseado nas permissões do usuário
    const getFilteredItems = () => {
        return menuItems.items.map((group) => {
            if (group.type === 'group' && group.children) {
                // Filtra os filhos do grupo baseado nas permissões
                const filteredChildren = group.children.filter((child) => {
                    // Remove o menu "Gestão de Usuários" se o usuário não tiver permissão
                    if (child.id === 'user-management' && !canManageUsers) {
                        return false;
                    }
                    // Remove o menu "Relatórios" se o usuário não tiver permissão
                    if (child.id === 'reports-menu' && !canViewCommissionReports) {
                        return false;
                    }
                    if (child.id === 'attendances-menu' && !canViewAttendances) {
                        return false;
                    }
                    // Remove itens marcados como superuserOnly se o usuário não for superusuário
                    if (child.superuserOnly && !isSuperuser) {
                        return false;
                    }
                    return true;
                });

                return {
                    ...group,
                    children: filteredChildren
                };
            }
            return group;
        });
    };

    const filteredItems = getFilteredItems();

    const navItems = filteredItems.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
